import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { OAuthModule } from "angular-oauth2-oidc";
import { environment } from "../environments/environment";
import { AuthService } from "./shared/services/auth.service";
import { TopNavComponent } from './core/top-nav/top-nav.component';
import { NotificationsComponent } from './core/notifications/notifications.component';
import { FooterComponent } from './core/footer/footer.component';
import { HomeComponent } from './home/home.component';

@NgModule({
  declarations: [
    AppComponent,
    TopNavComponent,
    NotificationsComponent,
    FooterComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: environment.oidc.allowedURLs,
        sendAccessToken: true
      }
    })
  ],
  providers: [AuthService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
